module.exports = __webpack_public_path__ + "static/media/tap_03_img01.ce476efb.png";